import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const sidebarCollapsedAtom = atomWithStorage<boolean>('admin.sidebar.collapsed', false);

/** Whether the mobile sidebar drawer is currently open. Not persisted. */
export const mobileNavOpenAtom = atom<boolean>(false);
